import MuiToggleButton from '@mui/material/ToggleButton';

type ToggleButtonProps = {
  children: React.ReactNode;
  onClick?: (evt: any) => void;
  disabled?: boolean;
  fontSize?: string;
  key: number,
  value: number,
}

const ToggleButton: React.FunctionComponent<ToggleButtonProps> = (props: ToggleButtonProps) => {
  return (<MuiToggleButton
    sx={{fontSize: props?.fontSize || '14px'}}
    key={props.key}
    onClick={props?.onClick}
    value={props.value}
  >{props.children}
  </MuiToggleButton>);
};

export default ToggleButton;